import EmptyScene from './EmptyScene';

export default EmptyScene;
